import { Skeleton } from '@mui/material';
import { useState, useEffect } from 'react';
import {
  FooterWrapper,
  FooterTopSection,
  FooterTopContent,
  FooterLeftSection,
  FooterLogoContainer,
  FooterLogo,
  FooterAwardSection,
  FooterAwardText,
  FooterAwardImage,
  FooterDivider,
  FooterBottomSection,
  FooterText,
  FooterLink,
  FooterLinksSection,
  FooterLinksContainer,
  FooterNavLink,
  FooterNavButton,
  FooterLinkDivider,
} from './styles/components';
import { Box } from '@mui/material';

export default function FooterNew() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);



  return (
    <FooterWrapper>
      {loading ? (
        <>
          <FooterTopSection>
            <Box sx={{
              display: 'flex',
              width: '100%',
              maxWidth: '1152px',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: { xs: '40px', md: 0 },
            }}>
              <Skeleton
                variant="rectangular"
                sx={{
                  width: { xs: 180, md: 243 },
                  height: { xs: 30, md: 40.5 },
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '4px'
                }}
              />
              <Skeleton
                variant="text"
                sx={{
                  width: { xs: '100%', md: '50%' },
                  height: { xs: 40, md: 50 },
                  bgcolor: 'rgba(255, 255, 255, 0.2)'
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: { xs: 100, md: 134 },
                  height: { xs: 45, md: 60 },
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '4px'
                }}
              />
            </Box>
            <Skeleton
              variant="rectangular"
              sx={{
                width: '100%',
                height: 1,
                maxWidth: { xs: '100%', md: '1152px' },
                bgcolor: 'rgba(255, 255, 255, 0.2)'
              }}
            />
          </FooterTopSection>
          <Box sx={{
            width: '100%',
            maxWidth: '1200px',
            padding: { xs: '0 16px', md: '0 24px' },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}>
            <Skeleton variant="text" width="100%" height={20} sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
            <Skeleton variant="text" width="95%" height={20} sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
            <Skeleton variant="text" width="90%" height={20} sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
            <Skeleton variant="text" width="100%" height={20} sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
            <Skeleton variant="text" width="85%" height={20} sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
          </Box>
        </>
      ) : (
        <>
          <FooterTopSection>
            <FooterTopContent>
              <FooterLeftSection>
                <FooterLogoContainer>
                  <FooterLogo src="/images/constenewImg/logo-constellation.svg" alt="Constellation" />
                </FooterLogoContainer>
                <FooterAwardSection>
                  <FooterAwardText>
                    6-Time Winner Among Texas' Top Electricity Providers
                  </FooterAwardText>
                  <FooterAwardImage src="/images/constenewImg/top-providers-2025-min.png" alt="texas" />
                </FooterAwardSection>
              </FooterLeftSection>
            </FooterTopContent>
            <FooterLinksSection>
              <FooterLinksContainer>
                <FooterNavButton 
                  id="ot-sdk-btn"
                  className="ot-sdk-show-settings"
                >
                  Your Privacy Choices
                </FooterNavButton>
                <FooterLinkDivider>|</FooterLinkDivider>
                <FooterNavLink href="https://www.constellation.com/privacy-policy.html" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </FooterNavLink>
                <FooterLinkDivider>|</FooterLinkDivider>
                <FooterNavLink href="https://www.constellationenergy.com/terms-of-use.html" target="_blank" rel="noopener noreferrer">
                  Terms of Use
                </FooterNavLink>  
              </FooterLinksContainer>
            </FooterLinksSection>
          </FooterTopSection>
          <FooterBottomSection>
            <FooterText>
              Our prices are subject to change during the term only if there are changes in TDU charges, fees imposed by Electric Reliability Council of  Texas ("ERCOT") or the Texas Reliability Entity ("TRE"), or cost imposed by changes in federal, state or local laws that impose new or modified fees or cost on Constellation that are beyond Constellation's control.
            </FooterText>
            <FooterText>                 
              © 2025 Constellation Energy Resources, LLC. The offerings described herein are those of either Constellation NewEnergy, Inc., Constellation NewEnergy-Gas Division, LLC, Constellation Connect, LLC or Constellation Home Products & Services, LLC (d/b/a Constellation Home in Maryland and Pennsylvania and d/b/a Constellation in Georgia and Texas), each affiliates of each other. The prices of Constellation are not regulated by any state Public Utility Commission. You do not have to buy Constellation electricity, natural gas or any other products to receive the same quality regulated service from your local utility. Brand names and product names are trademarks or service marks of their respective holders. All rights reserved. Errors and omissions excepted.
            </FooterText>
            <FooterText>
              You can obtain important standardized information that will allow you to compare this product with other offers by contacting us at {' '}
              <FooterLink href="https://www.constellation.com">www.constellation.com</FooterLink>. The comparison and rate information provided on this site is for illustrative purposes only. Actual pricing and savings may vary depending on your usage, utility provider, and plan selection.
            </FooterText>
            <FooterText>
              Electricity or Gas Supplier License/Order #s: CA 1359, CTA0032; CT 06-07-11, 01-06; DE 00-162; DC GA06-2, EA01-5; GA GM-46; IL 16-0205, 17-0330; IA G-0010; ME 2000-989; MD IR-655, IR-311, IR-500, IR-228, 107-2276; MA GS-030, CS-015; MI U-14867, U-13660; NE NG-0043; NH DM 17-024; NJ GSL-0101, ESL-0016; OH 09-153G, 00-003E; PA A-125095, A-110036; OR ES4, RI 2379(Z1), D-96-6(E); TX 10014, B07305101; VA G-26, G-51, E-11A
            </FooterText>
            <FooterText>
              TX Licenses HVAC TACLA 00107498R, Electrical TECL 343159, Service Plan TSCP #684, Plumbing #43217, TREC #168
            </FooterText>
            <FooterText>
              *Only new customer successful enrollments with Constellation. For residential plans with a term of 12 months or more. Customer will receive up to a $150 gift card to help cover the current retail electric provider’s cancellation fee. The maximum total of gift cards is $150 per name and per account. The total cannot exceed $450 per calendar year. After completing the switch to Constellation, the customer must complete the form at{' '}<FooterLink href="https://www.constellation.com/promo">constellation.com/promo</FooterLink>{' '} and include a copy of their new Constellation bill and a copy of the last bill from their current retail electric provider showing a cancellation fee. Gift card link will be sent within 2-3 weeks after Constellation receives the customer’s documentation. Gift cards are issued by Virtual Incentives. Valid email address required for receipt of gift card. Gift cards will not have cash access. For any questions about your gift card, call {' '}<FooterLink href="tel:877-321-2641">877-321-2641</FooterLink>. Terms and conditions are applied to gift cards. Please see the merchant gift card for additional terms and conditions, which are subject to change at merchant’s sole discretion. Constellation will share your name and email address with Virtual Incentives for reward fulfillment only. Reward link expires in 3 months.
            </FooterText>
          </FooterBottomSection>
        </>
      )}
    </FooterWrapper>
  );
}
